const INITIAL_STATE = [
    {
        permissaoAcesso: null
    },
];


export default function modalStatus(state = INITIAL_STATE, action) {
    switch (action.type) {             
        case 'SET_PERMISSAO_ACESSO':
            return [{ permissaoAcesso: action.payload.permissaoAcesso }];
        default:
            return state;
    }
}